// extracted by mini-css-extract-plugin
export default {"searchBox":"KeywordInput_searchBox__ixfhM","resetButton":"KeywordInput_resetButton__NQD+a","searchIcon":"KeywordInput_searchIcon__aRx-V"};